import axios, { AxiosInstance } from "axios";
import { placeEnquiryEndpoints } from "../utils/placeEnquiryEndpoints";

export function createPlaceEnquiryServices(apiBaseUrl: string, authToken: string) {
  const axiosInstance: AxiosInstance = axios.create({
    baseURL: apiBaseUrl,
    headers: { Authorization: authToken },
  });

  return {
    async getInsuranceUsers(userSubType: "SPOC" | "SURVEYOR") {
      const { data } = await axiosInstance.get(
        placeEnquiryEndpoints.getInsuranceUsers(userSubType),
      );
      return Array.isArray(data) ? data : [];
    },
    async getXpressCustomer(search: string) {
      const url = `${placeEnquiryEndpoints.searchXpressCustomer}${search}`;
      const { data } = await axiosInstance.get(url);
      return data;
    },
    async addMedia(formData: FormData) {
      const { data } = await axiosInstance.post(placeEnquiryEndpoints.addMedia, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return data;
    },
    async deleteMedia(mediaId: string) {
      await axiosInstance.delete(placeEnquiryEndpoints.deleteMedia(mediaId));
    },
    async getOrderMediaConfig() {
      const { data } = await axiosInstance.get(placeEnquiryEndpoints.mobileConfig);
      return data;
    },
    async getCarMakers() {
      const { data } = await axiosInstance.get(placeEnquiryEndpoints.getCarMakers());
      return data;
    },
    async getStateCity() {
      const { data } = await axiosInstance.get(placeEnquiryEndpoints.getStateCity);
      return data;
    },
    async getInsurers() {
      const { data } = await axiosInstance.get(placeEnquiryEndpoints.getInsurers);
      return data;
    },
    async getBrands() {
      const { data } = await axiosInstance.get(placeEnquiryEndpoints.getBrands);
      return data;
    },
    async searchPartWithPartNumber(partNumber: string) {
      try {
        const { data } = await axiosInstance.get(
          placeEnquiryEndpoints.getSearchedPartList(partNumber)
        );
        const arr = Array.isArray(data) ? data : data ? [data] : [];
        return arr.map((p: any) => ({ ...p, _id: p._id || p.partId }));
      } catch {
        return [];
      }
    },
    async getSearchedPartListBulk(
      parts: { partNumber: string; orderedQuantity: number }[],
      onProgress?: (percent: number) => void
    ) {
      const url = `${apiBaseUrl}${placeEnquiryEndpoints.getSearchedPartListBulk(parts)}`;
      const { data } = await axiosInstance.get(url, {
        onDownloadProgress: (e) => {
          if (e.total && onProgress) {
            onProgress(Math.round((e.loaded * 100) / e.total));
          }
        },
      });
      return data;
    },
  };
}
